import React, { useState } from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import FeaturedProject from '../components/FeaturedProject';
import GallerySection from '../components/GallerySection';
import HowItWorksSection from '../components/HowItWorksSection';
import CTASection from '../components/CTASection';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import Header from '../components/Header';

const Home = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <FeaturedProject />
        <GallerySection />
        <HowItWorksSection />
        <CTASection />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
